<template>
    <div>
      <trademark-provisional-case-instruction-list></trademark-provisional-case-instruction-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  